import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import { OpportunityWatch } from './OpportunityWatch';
/** Canonical Opportunities, including manual threads, need no Notice drawer. */ export function OpportunityWatchEntry() {
    const [params, setParams] = useSearchParams();
    if (params.get('notice')) return null;
    return /*#__PURE__*/ _jsx(OpportunityWatch, {
        onNavigate: (noticeId)=>setParams((previous)=>{
                const next = new URLSearchParams(previous);
                next.set('notice', noticeId);
                return next;
            })
    });
}
